export default __webpack_public_path__ + "static/media/ts_service.551d76f1.svg";